import { useContext, useMemo } from "react";
import {
    AutocompleteInput,
    BooleanInput,
    DeleteButton,
    Edit,
    FormTab,
    ReferenceInput,
    required,
    SaveButton,
    TabbedForm,
    TextField,
    TextInput,
    Toolbar
} from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";
import { Spacer } from "../../components/spacer";

const CustomToolbar = (props) => {

    const context = useContext(AppContext)
    const canDelete = context?.profile?.name === ProfileEnum.SUPERADMIN

    return (
        <Toolbar {...props}>
            <SaveButton
                label="Salvar"
                submitOnEnter={false}
                size={'small'}
            />
            <Spacer />
            {canDelete && (
                <DeleteButton
                    label="Excluir"
                    submitOnEnter={false}
                    size={'small'}
                />
            )}
        </Toolbar>
    )
}


const UserContextEdit = (props) => {

    const context = useContext(AppContext)
    const emailHelperText = 'Para melhor utilização do sistema de notificações via email, não recomendamos a utilização de endereços de email @outlook, @hotmail e @live.';
    const allowedEdition = useMemo(() => {
        return context?.profile?.name === ProfileEnum.SUPERADMIN
            || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL
            || context.profile.name === ProfileEnum.ADMIN
            || context.profile.name === ProfileEnum.SECRETARY
    }, [context?.profile?.name])

    return (
        <Edit mutationMode="pessimistic" {...props}>
            <TabbedForm toolbar={<CustomToolbar />}>
                <FormTab label={'Dados Gerais'}>

                    {
                        !!allowedEdition ? (
                            <TextInput source="user.name" label={'Nome'} fullWidth />
                        ) : (
                            <TextField source="user.name" label={'Nome'} fullWidth />
                        )
                    }
                    {
                        !!allowedEdition ? (
                            <TextInput source="user.email" label={'Email'} type={'email'} fullWidth helperText={emailHelperText} />
                        ) : (
                            <TextField source="user.email" label={'Email'} type={'email'} fullWidth helperText={emailHelperText} />
                        )
                    }

                    <TextField source="user.phone" label={'Telefone'} emptyText="Não informado" fullWidth />
                    <BooleanInput source="active" style={{ marginBlock: '8px' }} label={'Ativo'} fullWidth />

                    {allowedEdition && (
                        <ReferenceInput source="profile.id" label="Perfil" reference="profiles" validate={[required()]} fullWidth>
                            <AutocompleteInput options={{
                                suggestionsContainerProps: {
                                    modifiers: {
                                        computeStyle: {
                                            enabled: true,
                                            gpuAcceleration: false,
                                        },
                                        applyStyle: {
                                            enabled: true,
                                        },
                                    },
                                }
                            }} fullWidth />
                        </ReferenceInput>
                    )
                    }

                    {allowedEdition &&
                        <ReferenceInput label="Unidade" source="institution_branch.id" reference="institution-branches" perPage={999}
                            filterToQuery={(text) => ({ "institution_branch.name": text })} sort={{ field: "name", order: "ASC" }} validate={[required()]} fullWidth>
                            <AutocompleteInput
                                source="name"
                                emptyText="Todos"
                                optionText={val => `${val?.institution?.name} - ${val?.name}`}
                                optionValue="id"
                                fullWidth
                            />
                        </ReferenceInput>
                    }
                </FormTab>
            </TabbedForm>
        </Edit>
    )
}

export default UserContextEdit;